import '../css'

addEventListener('change', ({ target }) => {
  if (target.matches('select[name="feast"]')) {
    fetch(`/admin/reports/sites?feast=${target.value}`)
      .then(resp => {
        if (resp.ok) return resp.json()
      })
      .then(json => {
        const select = document.querySelector('select#report_site')
        select.innerHTML = json.map(site => `<option value="${site.id}">${site.name}</option>`).join('')
      })
  }
})

addEventListener('click', ({ target }) => {
  if (target.matches('#report-existing-files .fa-trash-can')) {
    target.closest('li.list-group-item')?.remove()
  }
})
